import React, { forwardRef } from 'react';
import MUISwitch, {
  SwitchProps as MUISwitchProps,
} from '@material-ui/core/Switch';

interface SwitchProps extends MUISwitchProps {}

const Switch = forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => {
  const { color = 'default', ...rest } = props;

  return <MUISwitch {...rest} ref={ref} color={color} />;
});

Switch.displayName = 'Switch';

export default Switch;
